// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media(max-width:599px){.v-btn:not(.v-btn--round).v-size--x-small[data-v-9922292e]{padding:0 3px}}#exportButton:focus i[data-v-9922292e]:before,#exportButton:focus span[data-v-9922292e]{color:#000!important}", ""]);
// Exports
module.exports = exports;
